import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { ToWords } from 'to-words';
import seelImage from './assets/images/seal.png';
import sign from './assets/images/sign.png';
import OswaldRegular from './assets/fonts/Oswald-Regular.ttf';
import reciept_kdm from './assets/pdf/reciept_kdm.pdf';

export async function generateReciept({ name, amount, being, secondLine, mode, date, receiptNo }) {
    try {
        const response = await fetch(reciept_kdm);
        const pdfBytes = await response.arrayBuffer();
        const bytes = new Uint8Array(pdfBytes)

        const pdfDoc = await PDFDocument.load(bytes);
        pdfDoc.registerFontkit(fontkit);

        // Load Oswald font
        const oswaldFontBytes = await fetch(OswaldRegular).then(res => res.arrayBuffer());
        const oswalFont = await pdfDoc.embedFont(oswaldFontBytes)

        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        // Load images
        const seelImageBytes = await fetch(seelImage).then(res => res.arrayBuffer());
        const signImageBytes = await fetch(sign).then(res => res.arrayBuffer());

        const toWords = new ToWords({
            localeCode: 'en-IN',
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: false,
                currencyOptions: {
                    // can be used to override defaults for the selected locale
                    name: '',
                    plural: '',
                    symbol: '₹',
                    fractionalUnit: {
                        name: '',
                        plural: '',
                        symbol: '',
                    },
                },
            },
        });
        let amountInWords = toWords.convert(amount);

        // Draw text
        await drawAcademy({
            page: firstPage,
            font: oswalFont,
            name: name,
            date: date,
            secondLine: secondLine,
            being: being,
            mode: mode,
            amount: amount,
            amountText: amountInWords,
            seelBytes: seelImageBytes,
            signBytes: signImageBytes,
            receiptNo: receiptNo
        });

        // Save modified PDF bytes
        const modifiedPdfBytes = await pdfDoc.save();
        return modifiedPdfBytes;
    } catch (error) {
        console.error('Error modifying PDF:', error);
        throw new Error('Error modifying PDF');
    }
}

export const drawAcademy = async ({ page, font, name, date, being, secondLine, mode, amount, amountText, seelBytes, signBytes, receiptNo }) => {
    const seelImage = await page.doc.embedPng(seelBytes);
    const signImage = await page.doc.embedPng(signBytes);

    page.drawText(name, {
        x: 180,
        y: 134,
        size: 13,
        font: font,
        color: rgb(0, 0, 0),
    });
    // page.drawText(date, {
    //     x: 485,
    //     y: 200,
    //     size: 11,
    //     font: font,
    //     color: rgb(0, 0, 0),
    // });
    page.drawText(receiptNo, {
        x: 450,
        y: 230,
        size: 10,
        color: rgb(1, 0, 0),
    });
    page.drawText(secondLine, {
        x: 50,
        y: 110,
        size: 13,
        font: font,
        color: rgb(0, 0, 0),
    });
    page.drawText(amountText, {
        x: 120,
        y: 84,
        size: 13,
        font: font,
        color: rgb(0, 0, 0),
    });
    page.drawText(date, {
        x: 330,
        y: 59,
        size: 11,
        font: font,
        color: rgb(0, 0, 0),
    });
    page.drawText(being, {
        x: 440,
        y: 59,
        size: 13,
        font: font,
        color: rgb(0, 0, 0),
    });
    if (mode) {
        page.drawText(mode, {
            x: 180,
            y: 59,
            size: 13,
            font: font,
            color: rgb(0, 0, 0),
        });
    }
    page.drawText(`${amount}/-`, {
        x: 60,
        y: 23,
        size: 22,
        font: font,
        color: rgb(1, 0, 0),
    });
    page.drawImage(seelImage, {
        x: 300,
        y: 3,
        width: 50,
        height: 50
    });
    page.drawImage(signImage, {
        x: 380,
        y: 15,
        height: 40,
        width: 60,
    });
};